import React from "react";
import { useLocalization } from "utilities/hooks/use-localization";

const cssBaseClass = "c-chat-offline-tooltip-content";

const ChatOfflineTooltipContent: React.FC = () => {
    const { t } = useLocalization();

    return (
        <>
            <div className={`${cssBaseClass}__title`}>
                {t("offline-fallback-title")}
            </div>
            <div className={`${cssBaseClass}__description`}>
                {t("chat-offline-description")}
            </div>
        </>
    );
};

export default ChatOfflineTooltipContent;
